import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'filterConditionValues',
})

//this pipe returns errors one by one in condition values
export class FilterConditionValuesPipe implements PipeTransform {
    transform(value:any[], searchValue:any):any {
        let newArr:any[] = []
        value.forEach((elem,index)=>{
            if(searchValue){
                if(typeof(elem)=='number'){
                    if(elem.toString().includes(searchValue)){
                        newArr.push([elem, index])
                    }
                }else{
                    if(elem.includes(searchValue)){
                        newArr.push([elem,index])
                    }
                }
            }else{
                newArr.push([elem,index])
            }
        })
        return newArr
    }
}